/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdDropdownMenuProps, TdDropdownItemProps } from './type';

export const dropdownMenuDefaultProps: TdDropdownMenuProps = {
  closeOnClickOverlay: true,
  direction: 'down',
  duration: 200,
  showOverlay: true,
  zIndex: 11600,
};

export const dropdownItemDefaultProps: TdDropdownItemProps = {
  disabled: false,
  icon: undefined,
  multiple: false,
  options: [],
  optionsColumns: 1,
  placement: 'left',
  defaultValue: undefined,
};
